<template>
    <a-menu-item :key="menuInfo.key" v-bind="$props" :disabled="menuInfo.disabled" v-if="menuInfo.disabled==false">
        <router-link v-if="menuInfo.url && menuInfo.newTab == false" :to="menuInfo.url">
            <span :class="styles.title">{{ menuInfo.title }}</span>
            <span v-if="menuInfo.count?.value" class="badge badge-danger ml-2">{{ menuInfo.count?.value }}</span>
            <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]" />
        </router-link>

        <!-- Para abrir um url externo numa nova tab -->
        <a v-if="menuInfo.url && menuInfo.newTab == true" :href="menuInfo.url" target="_blank">
            <span :class="styles.title">{{ menuInfo.title }}</span>
            <span v-if="menuInfo.count?.value" class="badge badge-danger ml-2">{{ menuInfo.count?.value }}</span>
            <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]" />
        </a>

        <!-- menu normal -->
        <span v-if="!menuInfo.url" :to="menuInfo.url">
            <span :class="styles.title">{{ menuInfo.title }}</span>
            <span v-if="menuInfo.count?.value" class="badge badge-danger ml-2">{{ menuInfo.count?.value }}</span>
            <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]" />
        </span>
    </a-menu-item>
</template>

<script>
import { Menu } from 'ant-design-vue'

export default {
    name: 'SubMenu',
    props: {
        ...Menu.Item.props,
        menuInfo: {
            type: Object,
            default: () => {},
        },
        styles: {
            type: Object,
            default: () => {},
        },
    },

}

</script>
